import React from 'react';
import { motion, useSpring, useTransform } from 'framer-motion';

export default function Content({ mouseX, mouseY, onOpenModal }) {
  const springConfig = { damping: 30, stiffness: 100 };
  const smoothX = useSpring(mouseX, springConfig);
  const smoothY = useSpring(mouseY, springConfig);

  const x = useTransform(smoothX, [-1, 1], [-10, 10]);
  const y = useTransform(smoothY, [-1, 1], [-10, 10]);

  return (
    <motion.div
      style={{ x, y }}
      className="relative z-20 flex flex-col items-center text-center max-w-3xl mx-auto px-4 w-full"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
        className="relative w-full flex flex-col items-center"
      >
        <div className="absolute inset-0 bg-brand-green/20 backdrop-blur-md rounded-3xl border border-brand-cream/5 shadow-[0_8px_32px_rgba(0,0,0,0.3)] -z-10 scale-110 sm:scale-105" />

        <div className="py-6 sm:py-8 px-4 sm:px-12 w-full flex flex-col items-center">
          <h1 className="text-5xl sm:text-7xl md:text-[5.5rem] font-bold tracking-tighter font-serif text-brand-cream mb-3 drop-shadow-xl leading-none">
            MEE <span className="text-brand-gold">MATCHA</span>
          </h1>

          <p className="text-brand-gold tracking-[0.25em] uppercase text-xs sm:text-sm font-semibold mb-6 flex items-center gap-4">
            <span className="w-8 h-[1px] bg-brand-gold/50 hidden sm:block"></span>
            Ceremonial Grade A
            <span className="w-8 h-[1px] bg-brand-gold/50 hidden sm:block"></span>
          </p>

          <p className="text-brand-cream/80 text-sm sm:text-base font-light leading-relaxed max-w-md mx-auto mb-8 sm:mb-10">
            First Harvest · Organic · Spring Flush · Umami Rich<br />
            <span className="opacity-60 text-xs sm:text-sm mt-3 block font-serif italic tracking-wide">
              Sourced from Kagoshima, Japan
            </span>
          </p>

          <motion.button
            onClick={onOpenModal}
            whileHover={{ y: -4, scale: 1.02 }}
            whileTap={{ y: 0, scale: 0.98 }}
            className="group relative bg-brand-cream text-brand-green px-12 py-4 sm:px-16 sm:py-5 rounded-full font-bold tracking-[0.15em] text-sm sm:text-base overflow-hidden shadow-[0_10px_30px_rgba(142,44,44,0.3)] hover:shadow-[0_15px_40px_rgba(142,44,44,0.5)] transition-all duration-300 border border-transparent hover:border-brand-gold/50"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-brand-gold/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-in-out" />
            <span className="relative z-10">BUY NOW</span>
          </motion.button>
        </div>
      </motion.div>
    </motion.div>
  );
}